/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74bfec641d4189e7274e991164fabf9a>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Flask".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: labs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const FlaskIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.75 0h6.5v1.5h-.75v3.359l3.284 8.414A2 2 0 0 1 11.92 16H4.08a2 2 0 0 1-1.864-2.727L5.5 4.859V1.5h-.75zM7 1.5V5a.8.8 0 0 1-.051.273L5.689 8.5h4.622L9.05 5.273A.8.8 0 0 1 9 5V1.5zm3.896 8.5H5.104l-1.49 3.818a.5.5 0 0 0 .466.682h7.84a.5.5 0 0 0 .466-.682z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
FlaskIcon.displayName = 'FlaskIcon';
var _default = exports.default = FlaskIcon;